import React, { useEffect, useRef, useState } from 'react'
import GLOBAL from '../../Globals'
import {
    Button,
    Col,
    message,
    Popconfirm,
    Radio,
    Select,
    Spin,
    Table,
    Form,
    Modal,
    Tag,
} from 'antd'
import { RestApi } from '../../RestApi'
import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons'
import MCQQuestionDetailsModalNew from './FlagMcqQuestionDetailsModal'
import TextArea from 'antd/es/input/TextArea'
const OPEN_CONSTANT = 'open',
    CLOSE_CONSTANT = 'closed',
    ALL_CONSTANT = 'all'

const FlagMcq = () => {
    const [loading, setLoading] = useState(false)
    const [moreDataLoading, setMoreDataLoading] = useState(false)
    const [showTextAreaModal, setShowTextAreaModal] = useState(false)
    const [allCommentsModalVisible, setAllCommentsModalVisible] =
        useState(false)
    const [showMcqQuestionDetailsModal, setShowMcqQuestionDetailsModal] =
        useState(false)
    const [data, setData] = useState([])
    const [allCommentsData, setAllCommentsData] = useState([])
    const [subjects, setSubjects] = useState([])
    const [selectedSubject, setSelectedSubject] = useState('')
    const [nextURL, setNextURL] = useState('')
    const [selectedTab, setSelectedTab] = useState(OPEN_CONSTANT)
    const [recordDataAutoId, setRecordDataAutoId] = useState(0)
    const [mcqQuestionId, setMcqQuestionId] = useState(0)
    const [reportType, setReportType] = useState('')
    const [modalLoading, setModalLoading] = useState(false)
    const [form] = Form.useForm()
    const inputRef = useRef(null)
    const [count, setCount] = useState(0)

    useEffect(() => {
        setTimeout(() => {
            if (showTextAreaModal && inputRef.current) {
                inputRef.current.focus()
            }
        }, 100)
        // eslint-disable-next-line
    }, [showTextAreaModal, inputRef])

    useEffect(() => {
        getFlagItems()
        // eslint-disable-next-line
    }, [selectedTab, selectedSubject])

    useEffect(() => {
        getSubjects()
        // eslint-disable-next-line
    }, [])

    const getSubjects = () => {
        setLoading(true)
        RestApi.doGet(GLOBAL.URL.FLAGGED_MCQS.GET_SUBJECT_FILTER)
            .then((resp) => {
                setSubjects(resp.data)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const getFlagItems = () => {
        setLoading(true)
        const ApiURL = `${GLOBAL.URL.FLAGGED_MCQS.GET_FLAGGED_LIST}status=${selectedTab}&category=mcq&subCategory=&assignedTo=&subjectId=${selectedSubject}`
        RestApi.doGet(ApiURL)
            .then((response) => {
                const resp = JSON.parse(response.data)
                setData(resp.data)
                setNextURL(resp.next)
                setCount(resp.count)
            })
            .finally(() => setLoading(false))
    }

    const getMoreData = () => {
        setMoreDataLoading(true)

        RestApi.doGet(nextURL)
            .then((response) => {
                const resp = JSON.parse(response.data)
                setData((prevData) => [...prevData, ...resp.data])
                setNextURL(resp.next)
            })
            .finally(() => setMoreDataLoading(false))
    }

    const getAllComments = (item) => {
        if (!item.autoId) return

        RestApi.doGet(GLOBAL.URL.FLAGGED_MCQS.GET_FLAG_COMMENTS + item.autoId)
            .then((response) => {
                setAllCommentsData(response.data)
                setRecordDataAutoId(item.autoId)
                setAllCommentsModalVisible(true)
            })
            .finally(() => setLoading(false))
    }

    const handleStatus = (record) => {
        if (!!record.autoId && record.status === 'open') return

        setLoading(true)
        const payload = { autoId: record.autoId }
        let formbodyLevel = new FormData()
        formbodyLevel.append('payload', JSON.stringify(payload))

        RestApi.doPost(GLOBAL.URL.FLAGGED_MCQS.OPEN_FLAGGED, formbodyLevel)
            .then(() => {
                message.success('Opened!')
                getFlagItems()
            })
            .finally(() => setLoading(false))
    }

    const handleTabChange = (event) => {
        setSelectedTab(event.target.value)
    }

    const openTextAreaModal = (item) => {
        if (item.autoId) {
            setShowTextAreaModal(true)
            setRecordDataAutoId(item.autoId)
        }
    }

    const closeTextAreaModal = () => {
        form.resetFields()
        setShowTextAreaModal(false)
    }

    const openAllCommentsModal = (item) => {
        getAllComments(item)
    }

    const closeAllCommentsModal = () => {
        setAllCommentsModalVisible(false)
        setAllCommentsData([])
    }

    const openMcqQuestionDetailsModal = (id, report, autoId) => {
        if (!id) return

        setShowMcqQuestionDetailsModal(true)
        setMcqQuestionId(id)
        setReportType(report)
        setRecordDataAutoId(autoId)
    }
    const closeMcqQuestionDetailsModal = () => {
        setShowMcqQuestionDetailsModal(false)
    }

    const updateAndCloseQuestion = () => {
        const newData = data.map((item) => {
            if (item.id === mcqQuestionId) {
                return { ...item, status: 'closed' }
            }
            return item
        })

        setData(newData)
    }

    const onChangeSelectSubject = (value) => {
        setSelectedSubject(value ? value : '')
    }

    const { Option } = Select
    const getSubjectFilterOptions = () => {
        var options = []
        subjects.forEach((subject, index) => {
            options.push(
                <Option
                    value={subject.subjectId}
                    key={`${subject.name}-${index}`}
                >
                    {subject.name}
                </Option>
            )
        })

        return options
    }

    const postComment = () => {
        form.validateFields(['comments'])
            .then((values) => {
                setModalLoading(true)
                let url = GLOBAL.URL.ADD_FLAG_COMMENT
                values['autoId'] = recordDataAutoId
                let formbodyLevel = new FormData()
                formbodyLevel.append('payload', JSON.stringify(values))
                RestApi.doPost(url, formbodyLevel)
                    .then((response) => {
                        getFlagItems()
                        closeTextAreaModal()
                        message.success(response.data)
                        form.resetFields()
                    })
                    .finally(() => {
                        setModalLoading(false)
                    })
            })
            .catch(() => {
                //empty catch block
            })
    }

    const columns = [
        {
            title: 'Status',
            key: 'active',
            render: (_, record) => (
                <span>
                    {record.status !== OPEN_CONSTANT ? (
                        <Popconfirm
                            title="Click yes to confirm"
                            onConfirm={() => handleStatus(record)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button
                                style={{
                                    fontSize: 11,
                                }}
                                size="small"
                                type="default"
                                loading={loading}
                            >
                                Closed
                            </Button>
                        </Popconfirm>
                    ) : (
                        <Button
                            type="primary"
                            onClick={() => {
                                openMcqQuestionDetailsModal(
                                    record.id,
                                    record.reportType,
                                    record.autoId
                                )
                            }}
                            size="small"
                            style={{ fontSize: 11 }}
                            loading={loading}
                        >
                            Update & Close
                        </Button>
                    )}
                </span>
            ),
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (text, record) => (
                <span>
                    <span style={{ fontSize: 12 }}>{record.date}</span>
                </span>
            ),
        },
        {
            title: 'Report Type',
            dataIndex: 'reportType',
            key: 'reportType',
            render: (_, record) => (
                <div>
                    <div>
                        <Button
                            type="link"
                            onClick={() =>
                                openMcqQuestionDetailsModal(
                                    record.id,
                                    record.reportType,
                                    record.autoId
                                )
                            }
                            size="small"
                            style={{
                                fontSize: 14,
                                padding: 0,
                                textTransform: 'capitalize',
                            }}
                        >
                            {record.category} ({record.id})
                        </Button>
                    </div>
                    <span style={{ fontSize: 12 }}>Subject: {record.data}</span>
                    <br />
                    <br />
                    <span style={{ fontSize: 12 }}>
                        {`Reported By - ${record.user.firstName} ${record.user.lastName}`}
                    </span>
                    <div>
                        <span style={{ fontSize: 12 }}>
                            {record.reportType}
                        </span>
                    </div>
                </div>
            ),
        },
        {
            title: 'Comments',
            dataIndex: 'comments',
            key: 'comments',
            render: (text, record) => (
                <>
                    {record.latestComment && record.latestComment.comment ? (
                        <div>
                            {record.latestComment.comment}
                            <br />
                            <span style={{ fontSize: 10 }}>
                                {' ('}
                                {record.latestComment.user.firstName}
                                {', '}
                                {record.latestComment.date}
                                {')'}
                            </span>
                        </div>
                    ) : null}
                    <div>
                        <Button
                            type="link"
                            onClick={() => {
                                openTextAreaModal(record)
                            }}
                            size="small"
                            style={{ fontSize: 11, padding: 0 }}
                        >
                            Add Comment
                        </Button>
                        <br />
                        {record.latestComment &&
                        record.latestComment.comment ? (
                            <Button
                                type="link"
                                onClick={() => {
                                    openAllCommentsModal(record)
                                }}
                                size="small"
                                style={{ fontSize: 11, padding: 0 }}
                            >
                                All Comments
                            </Button>
                        ) : null}
                    </div>
                </>
            ),
        },
    ]

    const commentsColumns = [
        {
            title: 'Date',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => (
                <span style={{ fontSize: 11 }}>{record.date}</span>
            ),
        },
        {
            title: 'Comment',
            dataIndex: 'comment',
            key: 'comment',
        },
        {
            title: 'Commented By',
            dataIndex: 'commentedBy',
            key: 'commentedBy',
            render: (text, record) => <span>{record.user.firstName}</span>,
        },
    ]

    return (
        <div>
            <Spin spinning={loading}>
                <h2>Flagged</h2>
                <div>
                    <Radio.Group
                        onChange={handleTabChange}
                        defaultValue={OPEN_CONSTANT}
                    >
                        <Radio.Button value={OPEN_CONSTANT}>
                            {OPEN_CONSTANT}
                        </Radio.Button>
                        <Radio.Button value={CLOSE_CONSTANT}>
                            {CLOSE_CONSTANT}
                        </Radio.Button>
                        <Radio.Button value={ALL_CONSTANT}>
                            {ALL_CONSTANT}
                        </Radio.Button>
                    </Radio.Group>

                    <span style={{ marginLeft: 20 }}>
                        <Select
                            placeholder="Select Filter"
                            showSearch
                            allowClear={true}
                            filterOption={(input, option) =>
                                option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                            style={{ width: 350 }}
                            onChange={onChangeSelectSubject}
                        >
                            {getSubjectFilterOptions()}
                        </Select>
                        <Button type="link" onClick={getFlagItems}>
                            <div style={{ marginTop: 10 }}>
                                {loading ? (
                                    <LoadingOutlined style={{ fontSize: 20 }} />
                                ) : (
                                    <ReloadOutlined style={{ fontSize: 20 }} />
                                )}
                            </div>
                        </Button>
                    </span>
                </div>
                <Tag
                    color="geekblue"
                    style={{ marginTop: 10, display: 'table' }}
                >
                    {'Count - ' + count}
                </Tag>
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    size="small"
                    style={{ marginTop: 10 }}
                    rowKey="id"
                />

                {nextURL ? (
                    <Col style={{ textAlign: 'left', marginTop: 20 }}>
                        <Button
                            type="primary"
                            loading={moreDataLoading}
                            onClick={getMoreData}
                        >
                            More Data
                        </Button>
                    </Col>
                ) : null}

                <Modal
                    title={'Add Comment'}
                    open={showTextAreaModal}
                    onOk={postComment}
                    confirmLoading={modalLoading}
                    onCancel={closeTextAreaModal}
                    okText={'Add Comment'}
                >
                    <Form form={form} layout="horizontal">
                        <Form.Item
                            label="Comment"
                            name="comments"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter comment',
                                },
                            ]}
                        >
                            <TextArea
                                rows={3}
                                placeholder="Please enter comment"
                                autoFocus
                                ref={inputRef}
                            />
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title={'Comments'}
                    open={allCommentsModalVisible}
                    onCancel={closeAllCommentsModal}
                    footer={null}
                    width={800}
                >
                    <div>
                        <Button
                            size="small"
                            type="primary"
                            onClick={() => {
                                setAllCommentsModalVisible(false)
                                setTimeout(() => {
                                    setShowTextAreaModal(true)
                                }, 100)
                            }}
                        >
                            Add
                        </Button>
                    </div>

                    <Table
                        columns={commentsColumns}
                        dataSource={allCommentsData}
                        pagination={false}
                        size="small"
                        style={{ marginTop: 10 }}
                        rowKey="id"
                    />
                </Modal>

                <MCQQuestionDetailsModalNew
                    open={showMcqQuestionDetailsModal}
                    closeQuestionDetailsModal={closeMcqQuestionDetailsModal}
                    questionId={mcqQuestionId}
                    reportType={reportType}
                    autoId={recordDataAutoId}
                    isCloseTab={selectedTab.title === 'closed'}
                    updateAndCloseQuestion={updateAndCloseQuestion}
                />
            </Spin>
        </div>
    )
}

export default FlagMcq
